import React from 'react';
import PropTypes from 'prop-types';
import { InBCard } from './InBCard';
import styles from './InBStatus.module.css';

export const InBStatus = ({ InB, onCloseSidebar }) => {
  return (
    <div className={styles.container}>
      <div className='dashboard-title'>Unified Service Insights</div>
      <div className="dashboard-subtitle">Dashboards and analytics from your managed environment</div>
      <div className={styles.list}>
        {InB.map((s) => (
          <InBCard
            key={s.name}
            name={s.name}
            value={s.value}
            serviceKey={s.serviceKey}
            color={s.color}
            onCloseSidebar={onCloseSidebar}
          />
        ))}
      </div>
    </div>
  );
};

InBStatus.propTypes = {
  InB: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      serviceKey: PropTypes.string.isRequired,
      color: PropTypes.string
    })
  ).isRequired,
  onCloseSidebar: PropTypes.func
};
